<script setup lang="ts">
import dayjs from 'dayjs';
import { onMounted } from 'vue';

interface Props {
  compromisso?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    v-if="props.compromisso.data"
    :column="3"
    :label-style="{ width: '35%' }"
    bordered
  >
    <a-descriptions-item label="Demanda" :span="3">
      {{ props.compromisso.data.demanda.id }}
    </a-descriptions-item>
    <a-descriptions-item label="Criado em" :span="3">
      {{
        dayjs(props.compromisso.data.demanda.created_at).format(
          'DD/MM/YYYY HH:mm',
        )
      }}
    </a-descriptions-item>
  </a-descriptions>
</template>
